import React from 'react'
import {
    FormControl,
    FormLabel,
    Input as ChakraInput, InputLeftAddon,
    Textarea, Text, InputGroup, InputLeftElement,
    FormErrorMessage,
    InputRightElement,
  } from "@chakra-ui/react"
import { Icon } from '.'
  
const Input = React.forwardRef( ({error, icon, info, leftAddon, rightElement, clearable, required=false, onClear,  size, label, textarea = false, ...props}, ref) => {
    return(
        <FormControl isInvalid={error}>
            {label && <FormLabel fontSize="12px" fontWeight="600" textTransform="uppercase">{label} {required && <Text as={'span'} fontSize="xs" color="red">*</Text>}</FormLabel>}
            {
                info &&
                <Text mb="4" color="gray.500" fontSize="sm">{info}</Text>
            }
            <InputGroup size={size || 'md'}>
                {
                    icon &&
                    <InputLeftElement>
                        <Icon name={icon} fontSize="sm" mt="-2" color="gray.300" />
                    </InputLeftElement>
                }
                {
                    leftAddon &&
                    <InputLeftAddon bg="transparent" p={0} border={0}>
                        {leftAddon}
                    </InputLeftAddon>
                }
                { textarea ? <Textarea  {...props} ref={ref} /> :  <ChakraInput {...props} ref={ref} />}            
                {
                    (clearable && props.value) &&
                    <InputRightElement onClick={() => onClear()}>
                        <Icon  name="ios-close-circle" fontSize="20px" position="relative" top="-1.5" />
                    </InputRightElement>
                }
                {
                    (rightElement) &&
                    <InputRightElement>{rightElement}</InputRightElement>
                }
            </InputGroup>
            <FormErrorMessage>{error}</FormErrorMessage>
        </FormControl>
    )
})
export {Input}